module.exports = __webpack_public_path__ + "img/sliced-pizza.0d67c553.jpg";